import { FunctionComponent, useState, useMemo } from 'react';
import { Dialog, IDialogContentProps } from '@components/dialog/Dialog';

export interface IStepperProps {
  open: boolean;
  steps: IDialogContentProps[];
  nextTextButton: string;
  doneTextButton: string;
  cancelTextButton: string;
  backTextButton: string;
  handleCloseDialog: () => void;
}

export const DialogStepper: FunctionComponent<IStepperProps> = ({
  steps,
  nextTextButton,
  doneTextButton,
  cancelTextButton,
  backTextButton,
  handleCloseDialog,
  open,
  ...other
}) => {
  const [step, setStep] = useState<number>(0);
  const isFirstStep = useMemo(
    () =>
      (currentStep: number): boolean =>
        currentStep === 0,
    [],
  );
  const isLastStep = useMemo(
    () =>
      (currentStep: number): boolean =>
        currentStep === steps.length - 1,
    [steps.length],
  );

  const handleClose = () => {
    setStep(0);
    handleCloseDialog();
  };

  const handleNextStep = (): void => {
    if (isLastStep(step)) handleClose();
    else setStep((prevState) => prevState + 1);
  };

  const handleBackStep = (): void => {
    if (isFirstStep(step)) handleClose();
    else setStep((prevState) => prevState - 1);
  };

  return (
    <Dialog
      open={open}
      size='medium'
      type='defaultStepper'
      title={steps[step].title}
      description={steps[step].description}
      secondaryBtnText={isFirstStep(step) ? cancelTextButton : backTextButton}
      secondaryBtnAction={handleBackStep}
      primaryBtnText={isLastStep(step) ? doneTextButton : nextTextButton}
      primaryBtnAction={handleNextStep}
      handleCloseDialog={handleClose}
      {...other}
    />
  );
};
